import { render } from "./EditProjects.vue?vue&type=template&id=c3d2e716"
import script from "./EditProjects.vue?vue&type=script&lang=js"
export * from "./EditProjects.vue?vue&type=script&lang=js"

import "./EditProjects.vue?vue&type=style&index=0&id=c3d2e716&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__